(function(){
     'use strict';

     angular
        .module('app')
        .factory('UseraltService', UseraltService);

    UseraltService.$inject = ['$http'];

    function UseraltService($http){


        var service= {
           setIdioma:setIdioma
        };

        return service;


        function setIdioma(lang_id,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
               lang_id:lang_id
            });
            $http.post('/backend/altcrm/user/setidioma', data, config)
            .success(getContentSuccess)
            .error(getContentFailed);
            function getContentSuccess(data){ 
                callback(data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

       
    }
})();